"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _Shot = _interopRequireDefault(require("../components/Shot"));

var _ShotActions = _interopRequireDefault(require("../../../contexts/ShotActions"));

var Shot = function Shot(props) {
  var shotKey = props.shotKey,
      description = props.description,
      script = props.script,
      index = props.index,
      assetId = props.assetId,
      aspectRatio = props.aspectRatio,
      organisationId = props.organisationId,
      selectedShotIndex = props.selectedShotIndex,
      handleFilesChange = props.handleFilesChange;
  return _react.default.createElement(_ShotActions.default.Consumer, null, function (_ref) {
    var updateShot = _ref.updateShot,
        duplicateShot = _ref.duplicateShot,
        deleteShot = _ref.deleteShot,
        selectShot = _ref.selectShot,
        hasDeletePermission = _ref.hasDeletePermission;
    return _react.default.createElement(_reactBeautifulDnd.Draggable, {
      key: shotKey,
      draggableId: shotKey,
      index: index
    }, function (providedDraggable, snapshot) {
      return _react.default.createElement(_Shot.default, {
        id: "shot-".concat(index),
        index: index,
        provided: providedDraggable,
        snapshot: snapshot,
        description: description,
        script: script,
        assetId: assetId,
        key: shotKey,
        aspectRatio: aspectRatio,
        organisationId: organisationId,
        updateShot: updateShot(shotKey),
        deleteShot: deleteShot(shotKey),
        duplicateShot: duplicateShot(shotKey),
        isSelected: selectedShotIndex === index,
        selectShot: selectShot(index),
        hasDeletePermission: hasDeletePermission,
        handleFilesChange: handleFilesChange
      });
    });
  });
};

var _default = (0, _react.memo)(Shot);

exports.default = _default;